/**
 * Feature-related type definitions
 */

export interface FeatureAccess {
  hasAccess: boolean;
  featureId: string;
  tag: string;
  config?: unknown;
  limits?: unknown;
  accessRules?: unknown;
  usage?: number;
  reason?: string;
}

export interface UserPlan {
  id: string;
  name: string;
  description?: string;
  features?: string[];
  limits?: Record<string, unknown>;
}

export interface UserSubscription {
  id: string;
  status: 'active' | 'trialing' | 'canceled' | 'past_due';
  planId: string;
  currentPeriodEnd?: string;
  cancelAtPeriodEnd?: boolean;
  trialEnd?: string;
}

export type FallbackBehavior = 'hide' | 'disable' | 'blur' | 'upgrade';

export interface FeatureConfig {
  fallbackBehavior?: FallbackBehavior;
  cacheTimeout?: number;
  onFeatureBlock?: (featureName: string) => void;
  onUpgradeClick?: (featureName: string) => void;
}